@let isReadonly = isReadonly$ | async;

<form [formGroup]="form">
    <div class="d-flex justify-content-between">
        <div id="pillboxContainer" class="d-flex flex-wrap">
            @if (showVacsStatus) {
            <div>
                <rask-vacs-status></rask-vacs-status>
            </div>
            }
            <div>
                @if (!isSkogsvardFPVKontrakt) {
                <rask-pillbox
                    [ngClass]="{'viol3-color': kontrakt.viol3, 'viol2-color': !kontrakt.viol3 }"
                    [text]="getViolPillboxText()">
                    <rask-icon icon="far fa-edit" popoverTriggers="raskDefault">
                        <rask-viol-editor-popover></rask-viol-editor-popover>
                    </rask-icon>
                </rask-pillbox>
                }
            </div>
            @if (showGrotPillbox) {
            <div>
                <rask-pillbox [text]="kopplatKontraktLabel">
                    <rask-icon icon="far fa-edit" popoverTriggers="raskDefault" popoverClass="popover-no-max-width">
                        <div style="display: grid">
                            @if (!hasGrotKoppling && !isReadonly) {
                            <rask-action-button icon="far fa-copy" (click)="skapaGrot()"
                                [disabled]="isDirty">Skapa grot kontrakt</rask-action-button>
                            }
                            @for (grotKoppling of grotKopplingar; track grotKoppling) {
                            <rask-action-button icon="far fa-link"
                                (click)="gotoKopplatKontrakt(grotKoppling)" [disabled]="!hasGrotKoppling">{{
                                grotKoppling.koppladVKKontraktBenamning }}</rask-action-button>
                            }
                            @if (canUpdateFromRundvirke && !isReadonly) {
                            <rask-action-button icon="far fa-copy"
                                (click)="updateFromRundvirke()" [disabled]="isDirty">Uppdatera från
                                rundvirkeskontrakt</rask-action-button>
                            }
                        </div>
                    </rask-icon>
                </rask-pillbox>
            </div>
            }
            <rask-leverantors-organisationer-popover
                [control]="leverantorsOrganisationExternKodControl">
            </rask-leverantors-organisationer-popover>
        </div>
        <div id="headerIconsContainer">
            <rask-kontrakt-header-icons></rask-kontrakt-header-icons>
        </div>
    </div>

    <div class="w-100">
        <rask-virkeskop-validation-message
            entityType="kontrakt"
            [entityGuid]="kontrakt.guid">
        </rask-virkeskop-validation-message>
    </div>

    <div class="d-flex mt-2 mb-2">
        <rask-input class="col-4" label="Benämning"
            formControlName="benamning"
            [raskDisabledControl]="limitedAccess || isReadonly"
            raskVirkeskopRule [messageId]="['kontraktbenamning']" [entityGuid]="kontrakt.guid"
            [maxlength]="kontraktBenamningMaxLength">
        </rask-input>

        @if (!kontrakt.isSkogsvardFPVKontrakt) {
        <rask-simple-selector
            #kontraktTyp
            class="col-4"
            label="Kontraktstyp"
            [infoText]="kontraktstypInfotext"
            [value]="kontrakt.kontraktTyp"
            [disabled]="limitedAccess || isReadonly || (kontraktTypDisabled$ | async) || isSkogsvardskontrakt"
            [onBeforeChange]="beforeKontraktTypChange"
            (change)="typChanged(kontraktTyp.value)"
            [values]="kontrakttyperItems">
        </rask-simple-selector>
        }

        <rask-selector class="col-4" label="Status"
            [canDelete]="false"
            [raskDisabledControl]="limitedAccess || isReadonly"
            formControlName="status"
            [values]="kontraktStatusStates$ | async"
            (change)="statusChanged()"></rask-selector>
    </div>

    @if (!kontrakt.isSkogsvardFPVKontrakt) {
    <div class="d-flex flex-wrap">
        <!-- Giltighetstid fr.o.m. -->
        <div class="col-4 p-0">
            @if (kontrakt.isAnbud) {
            <rask-datepicker
                [raskDisabledControl]="limitedAccess || isReadonly"
                class="w-100"
                label="Giltighetstid fr.o.m."
                formControlName="anbudGiltighetFrom" (change)="setAnbudGiltighetChanged()">
            </rask-datepicker>
            }
            @if (kontrakt.isKontrakt) {
            <rask-datepicker
                [raskDisabledControl]="limitedAccess || isReadonly"
                raskVirkeskopRule [messageId]="['kontraktgiltighetstidfrom']" [entityGuid]="kontrakt.guid"
                class="w-100"
                label="Giltighetstid fr.o.m."
                formControlName="kontraktGiltigtFrom" (change)="setKontraktGiltighetChanged()">
            </rask-datepicker>
            }
        </div>
        <!-- Giltighetstid t.om. -->
        <div class="col-4 p-0">
            @if (kontrakt.isAnbud) {
            <rask-datepicker
                class="w-100"
                [raskDisabledControl]="limitedAccess || isReadonly"
                label="Giltighetstid t.o.m."
                formControlName="anbudGiltighetTom" (change)="setAnbudGiltighetChanged()">
            </rask-datepicker>
            }
            @if (kontrakt.isKontrakt) {
            <rask-datepicker
                raskVirkeskopRule [messageId]="['kontraktgiltighetstidtom']" [entityGuid]="kontrakt.guid"
                [raskDisabledControl]="limitedAccess || isReadonly"
                class="w-100"
                label="Giltighetstid t.o.m."
                formControlName="kontraktGiltigtTom" (change)="setKontraktGiltighetChanged()">
            </rask-datepicker>
            }
        </div>
        @if (!isSkogsvardskontrakt) {
        <rask-simple-selector
            #affarsform
            class="col-4"
            label="Affärsform"
            raskVirkeskopRule [messageId]="['affarsform']" [entityGuid]="kontrakt.guid"
            [value]="kontrakt.affarsform"
            [disabled]="limitedAccess || isReadonly || (affarsformDisabled$ | async) "
            infoText="Affärsform kan inte ändras när avtalet är osparat, kontraktet har skickats till VACS eller när ingående åtgärders arbetsorder har produktionsstatus Pågår.
                        Du kan skapa ett nytt kontrakt på samma avtal istället."
            [values]="affarsformerItems"
            [onBeforeChange]="beforeAffarsformChange"
            (change)="affarsformChanged(affarsform.value)"
            bindLabel="key"
            bindValue="value">
        </rask-simple-selector>
        }
    </div>
    }

    <div class="mb-4">
        @if (kontrakt.isSkogsvardFPVKontrakt)
        {
        <div class="d-flex">
            <rask-input class="col-4" label="Fastighetsbeteckning"
                [raskDisabledControl]="limitedAccess || isReadonly"
                formControlName="fastighetsbeteckning" [maxlength]="50" [showmaxlength]="true">
            </rask-input>
            <rask-input class="col-4" label="Markägare"
                [raskDisabledControl]="limitedAccess || isReadonly"
                formControlName="markagare" [maxlength]="100" [showmaxlength]="false">
            </rask-input>
        </div>
        <div class="mt-2">
            <div class="d-flex">
                <rask-input class="col-4" label="Telefon"
                    [raskDisabledControl]="limitedAccess || isReadonly"
                    formControlName="markagareTelefon" [maxlength]="50" [showmaxlength]="false">
                </rask-input>
                <rask-input
                    class="col-4"
                    label="E-Postadress"
                    [raskDisabledControl]="limitedAccess || isReadonly"
                    formControlName="markagareEpost" [maxlength]="100"
                    [showmaxlength]="false">
                </rask-input>
            </div>
        </div>
        }
        @else
        {
        <div class="mb-2 d-flex">
            <rask-input class="col-4" label="Län kommun distrikt (LKD)"
                [raskDisabledControl]="limitedAccess || isReadonly"
                formControlName="lkd" [maxlength]="6" [showmaxlength]="true">
            </rask-input>
            <rask-input class="col-4" label="Fastighetsbeteckning"
                [raskDisabledControl]="limitedAccess || isReadonly"
                formControlName="fastighetsbeteckning" [maxlength]="50" [showmaxlength]="true">
            </rask-input>
            <rask-checkbox [flexResize]="true" class="col-4" text="Taxeras som lantbruksenhet"
                [raskDisabledControl]="limitedAccess || isReadonly"
                formControlName="taxerasSomLantbruksenhet">
            </rask-checkbox>
        </div>
        }
        @if (visaSkordarmatningIsActive$ | async) {
            <rask-simple-selector
                [raskDisabledControl]="disableSkordarmatning() || isReadonly"
                label="Ersättningsgrundande mätning"
                class="col-4 ms-auto"
                formControlName="skordarmatning"
                [values]="matningTypSelectionList"
                bindLabel="text"
                bindValue="value">
            </rask-simple-selector>
        }
        @if (kontrakt.isAffarsformU6) {
            <rask-simple-selector
                [raskDisabledControl]="limitedAccess || isReadonly"
                label="Nettotyp"
                class="col-4 ms-auto"
                formControlName="nettotyp"
                [values]="nettotyperItems"
                bindLabel="text"
                bindValue="value">
            </rask-simple-selector>
        }
        @if (!isSkogsvardFPVKontrakt) {
            <rask-input
                class="col-4"
                label="Extern beteckning"
                formControlName="externBeteckning"
                [infoText]="externBeteckningInfotext"
                [maxlength]="30">
            </rask-input>
        }
    </div>
</form>